import { Container } from '@mui/material';
import './spinner.scss';

interface SpinnerProps {
  'data-testid'?: string;
}

const Spinner: React.FC<SpinnerProps> = (props) => {
  return (
    <Container sx={{padding:'2rem', marginLeft:'auto', marginRight: 'auto'}} data-testid={props['data-testid']}>
      <div className="spinner"></div>
    </Container>
  );
};

export default Spinner;